import useWorkspaceSelected from 'Hooks/useWorkspaceSelected';

export default function useCurrency() {
    const { workspace } = useWorkspaceSelected();

    return workspace.currency;
}
